<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation>
			<v-row>
				<v-col cols="12" md="6">
					<v-text-money ref="amount" v-model="localData.amount" :label="'مبلغ*'" :error-messages="errorMessages" :rules="[() => localData.amount !== 0 || 'مبلغ وام را به صورت صحیح وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<div>مربوط به</div>
						<date-picker ref="targetMonth" v-model="localData.targetMonth" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM" :error-messages="errorMessages" :rules="[() => !!localData.targetMonth || 'تاریخ شروع را به صورت صحیح وارد کنید']" />
					</div>
					<small>برای این فیلد روز مهم نمی باشد و ماه و سال ملاک می باشد.</small>
				</v-col>
				<v-col cols="12">
					<v-text-field ref="description" v-model="localData.description" label="توضیحات*" :error-messages="errorMessages" :rules="[() => localData.description != '' || 'توضیحات را وارد کنید']" required />
				</v-col>
			</v-row>
			<small>*فیلدهای ستاره دار ضروری هستند.</small>
		</v-form>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck',false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyUserSavedMoneyView',
		components: {
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
			}
		},
		mounted() {
		},
		methods: {
			submit() {
				if (!this.$refs.form.validate()) { return }
				api.post('admin/userSavedMoney/' + (this.localData.id === emptyId ? 'create' : 'edit'), this.localData)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				api.get('admin/userSavedMoney/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === emptyId) Object.assign(this.localData, this.data)
							if (this.localData.targetMonth === '0001-01-01T00:00:00') { this.localData.targetMonth = '' }
							// this.localData.userLoanModel = this.data.userLoanModel
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
		},
	}
</script>
<style>
</style>
